import { render, staticRenderFns } from "./SamlLoginErrorPage.vue?vue&type=template&id=cb16ed6c"
import script from "./SamlLoginErrorPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SamlLoginErrorPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports